import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Error from 'components/UI/Error';
import Loading from 'components/UI/Loading';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import apiFetch from 'components/UI/helpers/fetch';
import Rating from '@material-ui/lab/Rating';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      margin: '15px 0',
    },
    ratingBox: {
      display: 'flex',
      gap: '10px',
    },
    message: {
      fontSize: '80%',
      marginTop: '0.75em',
    },
  };
});

export default function NPS({ module, id, data = { rating: 0, total: null }, align = null }) {
  const classes = useStyles();

  const [error, setError] = React.useState(null);
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(false);
    setResult(false);
  }, [module, id]);

  const send = (value) => {
    sendData({
      module: module,
      id: id,
      rating: value,
    });
  };

  const sendData = (params) => {
    setResult(false);
    setError(null);
    setLoading(true);
    apiFetch('/nps/rating', params)
      .then((data) => {
        console.log('fetchData ok', data);
        setResult(data);
        setLoading(false);
      })
      .catch(({ response, error, msg }) => {
        console.log('fetchData error', error, response);
        setResult(false);
        setError({ error: error, msg: msg });
        setLoading(false);
      });
  };
  const onHover = (newHover) => {};
  const onChange = (value) => {
    send(value);
  };

  const rating_str = result && 'average' in result ? result.average.rating : data.rating;
  const rating = parseFloat(rating_str);
  const total = result && 'average' in result ? result.average.total : data.total;

  return (
    <Box className={classes.root}>
      <Typography variant={'subtitle1'} gutterBottom={true}>
        Je donne mon avis&nbsp;:
      </Typography>
      <Box className={classes.ratingBox} style={align ? { justifyContent: align } : {}}>
        <Rating
          name={'rating'}
          style={{ display: 'inline-flex' }}
          value={rating}
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          onChangeActive={(event, newHover) => {
            onHover(newHover);
          }}
        />{' '}
        <Typography>
          <b>{!isNaN(rating) ? rating.toFixed(1) : ''}</b>
        </Typography>
        <Typography>({total})</Typography>
        <If condition={loading}>
          <Loading size={20} inline={true} text={false} />
        </If>
      </Box>
      <If condition={result}>
        <Typography className={classes.message}>Votre avis ({result.rating}/5) a bien été pris en compte.</Typography>
      </If>
      <If condition={error}>
        <Typography className={classes.message}>
          <Error result={error} inline={true} />
        </Typography>
      </If>
    </Box>
  );
}



// WEBPACK FOOTER //
// ./src/components/UI/NPS.jsx